import React, { useState } from 'react';
import TeacherDashboard from '../components/teacher/Dashboard';
import ClasseManager from '../components/teacher/ClasseManager';
import SuiviStage from '../components/teacher/SuiviStage';

export default function TeacherPage() {
  const [tab, setTab] = useState('dashboard');

  return (
    <div>
      <div className="flex gap-2 mb-6 border-b border-gray-200">
        {[
          { id: 'dashboard', label: 'Conventions' },
          { id: 'classes', label: 'Classes' },
          { id: 'suivi', label: 'Suivi de stage' },
        ].map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
              tab === t.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'dashboard' && <TeacherDashboard />}
      {tab === 'classes' && <ClasseManager />}
      {tab === 'suivi' && <SuiviStage />}
    </div>
  );
}
